module.exports = __webpack_public_path__ + "afb83989120f25e39b772094fcf2f683.svg";